import { useState, useEffect } from 'react';

type UseIsMobileResult = Record<string, boolean>;

const useIsMobile = (
  breakpoints: Record<string, number> = { isMobile: 768 }
) => {
  const getMatches = () =>
    Object.fromEntries(
      Object.entries(breakpoints).map(([key, value]) => [
        key,
        window.matchMedia(`(max-width: ${value}px)`).matches
      ])
    );

  const [matches, setMatches] = useState<UseIsMobileResult>(getMatches());

  useEffect(() => {
    const handleResize = () => setMatches(getMatches());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(breakpoints)]);

  return matches;
};

export default useIsMobile;
